import { DatTextCodeDto } from '@resources/resources';
import { Component, Input } from '@angular/core';

@Component({
  selector: 'body-vertical-table',
  templateUrl: './body-vertical-table.component.html'
})
export class BodyVerticalTableComponent {

  @Input() textCode : DatTextCodeDto;

}


// WEBPACK FOOTER //
// /home/vsts/work/1/s/digicerba-modules/digicerba-serveur-resultats/digicerba-serveur-resultats-web/src/angular/cerba/src/app/pages/cerba/pages/detail-resultat/body/vertical-table/body-vertical-table.component.ts